if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();

      document.body.style.overflow = "scroll";
      document.body.style.padding = "0";
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay-spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          removeElementsByScreenSize(this.modalContent);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          this.reorderQuickViewElements();
          super.show(opener);
          
          // Add smooth animation here
          this.modalContent.style.opacity = '0';
          this.modalContent.style.transform = 'scale(0.8)';
          this.modalContent.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          
          setTimeout(() => {
            this.modalContent.style.opacity = '1';
            this.modalContent.style.transform = 'scale(1)';
          }, 0);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay-spinner').classList.add('hidden');
        });

        document.body.style.overflow = "hidden";
        document.body.style.padding = "0 4px 0 0";
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }

    reorderQuickViewElements() {
      const twoColumnSection = this.modalContent.querySelector('.two-column-section');
      if (!twoColumnSection) return;

      const leftColumn = twoColumnSection.querySelector('.column-left');
      const rightColumn = twoColumnSection.querySelector('.column-right');
      if (!leftColumn || !rightColumn) return;

      // Find subscription form in left column
      const subscriptionForm = leftColumn.querySelector('form.installment');
      
      // Find elements we need to reorder - use more reliable selectors
      const titleBlock = Array.from(leftColumn.querySelectorAll('.block')).find(block => block.querySelector('.product-title'));
      const priceBlock = Array.from(leftColumn.querySelectorAll('.block')).find(block => block.querySelector('.price'));
      const buyButtonsBlock = rightColumn.querySelector('.buy-buttons-block');
      const quantityBlock = rightColumn.querySelector('.product-form-quantity')?.closest('.block') || rightColumn.querySelector('.product-form-quantity')?.parentElement;
      const productFormBlock = rightColumn.querySelector('.product-form')?.closest('.block') || rightColumn.querySelector('.product-form')?.parentElement;

      // Move title to right column at the beginning
      if (titleBlock && titleBlock.parentElement === leftColumn) {
        rightColumn.insertBefore(titleBlock, rightColumn.firstChild);
      }
      
      // Move price to right column, but extract subscription form first if it exists
      let subscriptionFormFromPrice = null;
      if (priceBlock && priceBlock.parentElement === leftColumn) {
        // Extract subscription form from price block if it exists
        subscriptionFormFromPrice = priceBlock.querySelector('form.installment');
        if (subscriptionFormFromPrice) {
          // Remove it from price block temporarily
          subscriptionFormFromPrice.remove();
        }
        
        // Insert price right after title
        const titleInRight = Array.from(rightColumn.querySelectorAll('.block')).find(block => block.querySelector('.product-title'));
        if (titleInRight) {
          rightColumn.insertBefore(priceBlock, titleInRight.nextSibling);
        } else {
          rightColumn.insertBefore(priceBlock, rightColumn.firstChild);
        }
      }

      // Handle subscription form - either from left column or extracted from price block
      let subscriptionBlockToMove = null;
      
      // First check if we extracted it from price block
      if (subscriptionFormFromPrice) {
        // Create a new block for the extracted subscription form
        subscriptionBlockToMove = document.createElement('div');
        subscriptionBlockToMove.className = 'block';
        subscriptionBlockToMove.setAttribute('data-column', 'right');
        subscriptionBlockToMove.appendChild(subscriptionFormFromPrice);
      } else if (subscriptionForm) {
        // Otherwise, get it from left column
        subscriptionBlockToMove = subscriptionForm.closest('.block') || subscriptionForm.parentElement;
      }
      
      // Move subscription block to right column after product form
      if (subscriptionBlockToMove && productFormBlock) {
        if (subscriptionBlockToMove.parentElement === leftColumn || !subscriptionBlockToMove.parentElement) {
          rightColumn.appendChild(subscriptionBlockToMove);
        }
        // Ensure it comes after product form
        if (productFormBlock.nextSibling !== subscriptionBlockToMove) {
          rightColumn.insertBefore(subscriptionBlockToMove, productFormBlock.nextSibling);
        }
      }

      // Set display order using CSS order property
      // Title first
      const titleInRight = Array.from(rightColumn.querySelectorAll('.block')).find(block => block.querySelector('.product-title'));
      if (titleInRight) {
        titleInRight.style.order = '1';
      }
      
      // Price second (right after title) - make sure it's not the subscription block
      const priceInRight = Array.from(rightColumn.querySelectorAll('.block')).find(block => {
        const hasPrice = block.querySelector('.price');
        const hasSubscription = block.querySelector('form.installment');
        // Price block should have price but subscription should be separate
        return hasPrice && !hasSubscription;
      });
      if (priceInRight) {
        priceInRight.style.order = '2';
      }
      
      // Variations third - buy buttons block contains variant radios
      if (buyButtonsBlock) {
        const buyButtonsParent = buyButtonsBlock.closest('.block');
        if (buyButtonsParent) {
          buyButtonsParent.style.order = '3';
        } else {
          buyButtonsBlock.style.order = '3';
        }
      }
      
      // Quantity fourth - it's inside the buy-buttons-block, so we need to handle it differently
      // Actually quantity is already inside buy-buttons-block, so we don't need separate order
      
      // Add to cart fifth - product form
      if (productFormBlock) {
        productFormBlock.style.order = '5';
      }
      
      // Subscription options sixth
      const subscriptionBlockFinal = Array.from(rightColumn.querySelectorAll('.block')).find(block => {
        const form = block.querySelector('form.installment');
        const hasPrice = block.querySelector('.price');
        return form && !hasPrice; // Has subscription form but not price
      });
      if (subscriptionBlockFinal) {
        subscriptionBlockFinal.style.order = '6';
      }
    }
  });
}